export default "__VITE_ASSET__CU_zUFVJ__"